import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Checkbox, Select, Typography, Divider, Card } from 'antd';
import { ReactComponent as LogoIcon } from '../assets/icons/LogoIcon.svg';
import { ReactComponent as WorldIcon } from '../assets/icons/WorldIcon.svg';
import { ReactComponent as GoogleIcon } from '../assets/icons/GoogleIcon.svg';
import './SignUp.css';
import api, { getApiUrl } from '../api';

const { Title, Text } = Typography;
const { Option } = Select;

const SignUp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Обработка токена из query-параметра после Google OAuth
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('token', token);
      navigate('/trade');
    }
  }, [location, navigate]);

  const handleSignUp = async (values) => {
    try {
      const response = await api.post('/api/users/register', {
        username: values.username,
        email: values.email,
        password: values.password,
      });

      if (response.status === 200) {
        navigate('/signin');
      }
    } catch (error) {
      console.error('Registration failed', error);
    }
  };

  return (
    <div className="sign-up-page">
      <div className="left-content">
        <div className="header">
          <div className="logo">
            <LogoIcon />
            <span className="logo-text">Orbit options</span>
          </div>
          <div className="country-selector">
            <Select
              defaultValue="USA"
              suffixIcon={<WorldIcon />}
              bordered={false}
            >
              <Option value="USA">USA</Option>
              <Option value="UK">UK</Option>
              <Option value="EU">EU</Option>
            </Select>
          </div>
        </div>

        <div className="content">
          <Card className="signup-card">
            <div className="container-section">
              <div className="form-content">
                <div className="top">
                  <Title level={2} className="heading">Sign up account</Title>
                </div>

                <Form
                  name="signup"
                  onFinish={handleSignUp}
                  initialValues={{ remember: true }}
                  className="signup-form"
                  layout="vertical"
                >
                  <Form.Item
                    name="username"
                    label="Username"
                    rules={[
                      { required: true, message: 'Please input your username!' },
                      { min: 3, message: 'Username must be at least 3 characters!' }
                    ]}
                  >
                    <Input placeholder="Enter your username" />
                  </Form.Item>

                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      { required: true, message: 'Please input your email!' },
                      { type: 'email', message: 'Please enter a valid email!' }
                    ]}
                  >
                    <Input placeholder="Enter your email" />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      { required: true, message: 'Please input your password!' },
                      { min: 6, message: 'Password must be at least 6 characters!' }
                    ]}
                  >
                    <Input.Password placeholder="Enter your password" />
                  </Form.Item>

                  <Form.Item name="remember" valuePropName="checked">
                    <Checkbox>Remember me</Checkbox>
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" className="sign-up-button" block>
                      Sign up
                    </Button>
                  </Form.Item>

                  <Divider className="divider">or</Divider>

                  <Button
                    icon={<GoogleIcon />}
                    className="google-button"
                    block
                    onClick={() => window.location.href = getApiUrl('/api/oauth2/authorize/google')}
                  >
                    Sign up with Google
                  </Button>

                  <div className="signin-prompt">
                    <Text>If you have not received an email</Text>
                    <Link to="/signin" className="signin-link">Sign in</Link>
                  </div>
                </Form>
              </div>
            </div>
          </Card>
        </div>

        <div className="footer">
          <div className="footer-content">
            <Text className="copyright">© 2025 Orbit options</Text>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          </div>
        </div>
      </div>
      <div className="right-content">
        {/* Background image set via CSS */}
      </div>
    </div>
  );
};

export default SignUp; 